export default __webpack_public_path__ + "/images/water-in-pool.jpg";